import { motion } from 'framer-motion';
import { PROCESS } from '@/lib/content';

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative bg-[#f2e8ce] py-24 md:py-32"
    >
      <div className="max-w-[1200px] mx-auto px-6 md:px-8">
        <div className="max-w-3xl mb-16 md:mb-24">
          <motion.p
            variants={fadeUp}
            custom={0}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="text-xs uppercase tracking-[0.3em] text-[#a1802f] mb-6"
          >
            La méthode Clarté &amp; Contrôle
          </motion.p>
          <motion.h2
            variants={fadeUp}
            custom={1}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="font-serif font-light text-[#1c1811] text-4xl md:text-5xl lg:text-6xl leading-[1.03] tracking-tight"
          >
            Une transformation
            <br />
            en <span className="italic text-[#a1802f]">cinq étapes</span>.
          </motion.h2>
          <motion.p
            variants={fadeUp}
            custom={2}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="mt-6 text-[#1c1811]/60 text-base md:text-lg leading-relaxed max-w-xl"
          >
            Comme on bâtit une maison solide : du terrain à la consolidation,
            chaque étape prépare la suivante pour une trajectoire qui tient dans
            la durée.
          </motion.p>
        </div>

        <div className="border-t border-[#1c1811]/20">
          {PROCESS.map((step, i) => (
            <motion.div
              key={step.n}
              variants={fadeUp}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: '-60px' }}
              data-testid={`process-step-${step.n}`}
              className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-baseline py-8 md:py-10 border-b border-[#1c1811]/20 transition-colors duration-300 hover:bg-[#f9f2e0]"
            >
              <div className="md:col-span-1 font-serif italic text-4xl md:text-5xl text-[#a1802f] leading-none">
                {step.n}
              </div>
              <h3 className="md:col-span-4 font-serif text-2xl md:text-4xl text-[#1c1811] leading-tight tracking-tight">
                {step.title}
              </h3>
              <p className="md:col-span-7 text-[#1c1811]/70 text-base md:text-lg leading-relaxed md:pl-4">
                {step.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
